import { render } from "./CarregarAlunos.vue?vue&type=template&id=186df6e3&scoped=true"
import script from "./CarregarAlunos.vue?vue&type=script&lang=js"
export * from "./CarregarAlunos.vue?vue&type=script&lang=js"

import "./CarregarAlunos.vue?vue&type=style&index=0&id=186df6e3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186df6e3"]])

export default __exports__